<script>
  import { Keys } from "@itslearning/atlas/keyboard/keys";
  import { normalizeKey } from "@itslearning/atlas/keyboard/normalize";
  import { onMount, createEventDispatcher } from "svelte";

  /** @type {number[]} */
  export let tabs = [];

  /** @type {number} */
  export let selectedIndex = 0;

  /** @type {object} */
  export let skipLink = undefined;

  let container;

  let previousSelectedIndex;

  const dispatch = createEventDispatcher();

  onMount(() => {
    const panels = container.getElementsByClassName("prom-tabs__content");

    for (let i = 0; i < panels.length; i++) {
      panels[i].hidden = i !== selectedIndex;
    }
  });

  $: if (previousSelectedIndex !== selectedIndex) {
    if (previousSelectedIndex !== undefined) {
      const links = container.getElementsByClassName("prom-tabs__link");
      const panels = container.getElementsByClassName("prom-tabs__content");

      if (links.length) {
        links[selectedIndex].focus();
      }

      if (panels.length) {
        panels[previousSelectedIndex].hidden = true;
        panels[selectedIndex].hidden = false;
      }
    }

    if (tabs && tabs.length > 0) {
      dispatch('tabChanged', {
        selectedTabIndex: selectedIndex,
        selectedTabId: tabs[selectedIndex].id
    });}

    previousSelectedIndex = selectedIndex;
  }

  function keyHandler(event) {
    const { key } = event;

    switch (normalizeKey(key)) {
      case Keys.LEFT: {
        event.preventDefault();
        changeSelectedTab(-1);
        break;
      }
      case Keys.RIGHT: {
        event.preventDefault();
        changeSelectedTab(+1);
        break;
      }
      case Keys.DOWN: {
        event.preventDefault();
        const panels = container.getElementsByClassName("prom-tabs__content");

        panels[selectedIndex].focus();
        break;
      }
    }
  }

  function clickHandler(event) {
    const links = container.querySelectorAll("[aria-selected]");
    const index = Array.prototype.indexOf.call(links, event.currentTarget);

    event.preventDefault();

    if (index !== -1 && index !== selectedIndex) {
      changeSelectedTab(index - selectedIndex);
    }
  }

  function changeSelectedTab(offset) {
    const nextIndex = selectedIndex + offset;

    if (nextIndex >= 0 && nextIndex < tabs.length) {
      selectedIndex = nextIndex;
    }
  }
</script>

<div bind:this={container}>
  {#if skipLink}
    <a class="prom-tabs__skip-link | screen-reader screen-reader-focusable" href={skipLink.href}>{skipLink.text}</a>
  {/if}
  <ul role="tablist" on:keydown={keyHandler} class="prom-tabs__tablist">
    {#each tabs as tab}
      <li role="presentation">
        <a
          id={tab.id}
          role="tab"
          href={tab.target}
          class="prom-tabs__link"
          on:click={clickHandler}
          aria-selected={tabs[selectedIndex].id === tab.id}
          tabindex={tabs[selectedIndex].id !== tab.id ? "-1" : null}>{tab.title}</a
        >
      </li>
    {/each}
  </ul>
  <slot />
</div>
